// 将pcm转为wav格式的数据
const pcmToWavBuffer = (pcmData, sampleRate = 16000, numChannels = 1) => {
    const buffer = new ArrayBuffer(44 + pcmData.byteLength);
    const view = new DataView(buffer);

    const pcmByteLength = pcmData.byteLength;
    const duration = pcmByteLength / (sampleRate * numChannels * 2); // 16-bit PCM, 每个样本2字节

    // 写入 WAV 文件头
    writeString(view, 0, 'RIFF');
    view.setUint32(4, 36 + pcmData.byteLength, true);  // 文件大小
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);  // fmt chunk size
    view.setUint16(20, 1, true);  // 格式 (1 = PCM)
    view.setUint16(22, numChannels, true);  // 通道数
    view.setUint32(24, sampleRate, true);  // 采样率
    view.setUint32(28, sampleRate * numChannels * 2, true);  // byte rate
    view.setUint16(32, numChannels * 2, true);  // block align
    view.setUint16(34, 16, true);  // 每样本位深度
    writeString(view, 36, 'data');
    view.setUint32(40, pcmData.byteLength, true);  // 数据大小

    // 将 PCM 数据写入 WAV 文件
    const pcmView = new Uint8Array(buffer, 44);
    pcmView.set(new Uint8Array(pcmData));

    return { buffer, duration };
};

const writeString = (view, offset, string) => {
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
};

/**
 * 通过pcm数据数组获取wav格式的blob
 * @param pcmData 
 * @returns 
 */
export const getWavBlobFromPcmBlob = async (pcmBlob: Blob, sampleRate = 16000, numChannels = 1) => {
    // 读取 PCM Blob 为 ArrayBuffer
    const pcmData = await pcmBlob.arrayBuffer();

    // 将 PCM 数据转换为 WAV
    const { buffer, duration } = pcmToWavBuffer(pcmData, sampleRate, numChannels);
    
    // 创建 WAV Blob
    const audioBlob = new Blob([buffer], { type: 'audio/wav' });

    return { audioBlob, duration };
};

/**
 * 获取
 * @param wavBlob 
 * @returns 
 */
export const getWavDurationFromBlob = async (wavBlob: Blob): Promise<number> => {
    const arrayBuffer = await wavBlob.arrayBuffer();
    const view = new DataView(arrayBuffer);

    const sampleRate = view.getUint32(24, true);  // 采样率
    const numChannels = view.getUint16(22, true); // 通道数
    const bitDepth = view.getUint16(34, true); // 采样位深（一般是16）

    const dataSize = view.getUint32(40, true); // PCM 数据大小
    const duration = dataSize / (sampleRate * numChannels * (bitDepth / 8));

    return duration;
};